<template>
  <div>
    <AdminDashboard v-if=" user.role=='ADMIN' "/>
    <AssigneeDashboard v-if=" user.role=='ASSIGNEE' "/>
  </div>
</template>

<script>
import AdminDashboard from "../pages/DashBoardLayouts/AdminDashboard.vue"
import AssigneeDashboard from "../pages/DashBoardLayouts/AssigneeDashboard.vue"

import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("Auth");
export default {
  name: "DashboardPage",
  components:{
    AdminDashboard,
    AssigneeDashboard
  },
  computed:{
    ...mapGetters({
      user: "getUser"
    })
  }
};
</script>

<style lang="scss" scoped></style>
